export default __webpack_public_path__ + "static/media/icon-kamera.9aa1a8e4.png";